import React, { Component }  from 'react'
import { connect } from 'react-redux'
import { Column, Table, AutoSizer  } from 'react-virtualized'
import 'react-virtualized/styles.css'
import * as R from 'ramda'
import { propertiesLLEx } from 'selectors/properties'
import tableActions from 'actions/table'
import {currentSort, prop, selectedRows, route} from 'selectors/common'
import {properties} from 'selectors/entities'

let select = (state, props) => ({
	sort: currentSort(props.entity)(state)
  , selectedRows: state.selectedProperty
  , route: route(state)
})

export class CommonTable extends Component {
    render(){
		let { props } = this
		let sort = props.sort
		let data = props.data || []
		let selectedRows = props.route[1] || props.selectedRows
		return(
	    <div
	        className="data-table"
	        style={{
	            width: "calc(100% - 5px)"
	          , height: "calc(100vh - 61px)"
			  , background: "#fff"
	        }}
	    >
	        <AutoSizer>
	            {({ width, height }) => (
	                <Table
	                    width={width}
	                    height={height}
	                    headerHeight={48}
	                    rowHeight={48}
	                    rowCount={data.length}
	                    rowClassName={(x)=>{
	                        if (x.index==-1) return "tableHeaderClass"
	                        else {
														if (data[x.index] && selectedRows == data[x.index]._id) return "tableRowClassSelected"
														else return "tableRowClass"
													}
	                    }}
	                    sortBy={sort.sortBy}
	                    sortDirection={props.sort.sortDirection}
	                    sort={(x)=>{props.SORT_CHANGE({entity: props.entity, ...x})}}
	                    onRowClick = {({ rowData }) => props.CHOOSE_ITEM(rowData._id)}
	                    rowGetter={({ index }) => data[index]}
	                >
										{props.children}
	                </Table>
	            )}
	        </AutoSizer>
	    </div>
    )
  }
}

export default connect(select, tableActions)(CommonTable)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/CommonTable.js